import React from 'react';
import PropTypes from 'prop-types';
import OrderSummaryGiftCheckbox from '../../order-summary-gift-checkbox';

import style from './style.module.less';

const GiftCheckbox = ({ salesOrderId }) => {
  return (
    <div className={style['order-summary-gift-details']}>
      <OrderSummaryGiftCheckbox salesOrderId={salesOrderId} />
    </div>
  );
};

GiftCheckbox.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

export default React.memo(GiftCheckbox);
